module.exports = __webpack_public_path__ + "img/Turkey.d7e961bf.png";